function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Duration");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Duration",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.97265625,16.9453125 C13.7871094,16.9453125 16.9453125,13.7871094 16.9453125,9.97265625 C16.9453125,6.16503906 13.7802734,3 9.96582031,3 C6.15820312,3 3,6.16503906 3,9.97265625 C3,13.7871094 6.16503906,16.9453125 9.97265625,16.9453125 Z M9.97265625,15.7832031 C6.74609375,15.7832031 4.16894531,13.1992188 4.16894531,9.97265625 C4.16894531,6.75292969 6.73925781,4.16210938 9.96582031,4.16210938 C13.1923828,4.16210938 15.7763672,6.75292969 15.7832166,9.97265625 C15.7900391,13.1992188 13.1992188,15.7832031 9.97265625,15.7832031 Z M9.96582031,10.7109375 C10.2324219,10.7109375 10.4443359,10.5058594 10.4443359,10.2324219 L10.4443359,5.625 C10.4443359,5.35839844 10.2324219,5.15332031 9.96582031,5.15332031 C9.69921875,5.15332031 9.49414062,5.35839844 9.49414062,5.625 L9.49414062,9.76074219 L6.39746094,9.76074219 C6.12402344,9.76074219 5.91894531,9.96582031 5.91894531,10.2324219 C5.91894531,10.5058594 6.12402344,10.7109375 6.39746094,10.7109375 L9.96582031,10.7109375 Z",
  id: "Duration",
  fill: "#14006B",
  fillRule: "nonzero"
}));

var SvgDuration = function SvgDuration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDuration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/duration.ef28734b.svg";
export { ForwardRef as ReactComponent };